<template>
  <div class="info">
    <div class="head-wrap content-padding">
    </div>
    <div class="content-padding">
      <div class="section-content">
        <img class="sec-title" src="@/assets/shuLan/block-1.png" />
        <div class="manage-info manage-info-title content">
          <div class="manage-info_content" style="padding-top: 0">
            <div class="input-wrap">
              <div class="key">业务员姓名</div>
              <div class="val">
                <van-field v-model="form.payPersonName" placeholder="请输入姓名" />
              </div>
            </div>
            <div class="input-wrap">
              <div class="key">业务员工号</div>
              <div class="val">
                <van-field v-model="form.payPersonNo" placeholder="请输入业务员工号" />
              </div>
            </div>
            <div class="input-wrap" style="margin-bottom: 0">
              <div class="key">业务员手机号</div>
              <div class="val">
                <van-field v-model="form.payPersonPhone" placeholder="请输入手机号" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="content" style="margin-top: -40px">
          <div
            class="manage-info manage-info-repeat"
            v-for="(item, index) in form.itemList"
            :key="index"
          >
            <div class="manage-info_content">
              
              <section class="section-content">
                <img class="sec-title" src="@/assets/shuLan/block-2.png" />
                <div class="input-wrap">
                  <div class="key">姓名</div>
                  <div class="val">
                    <van-field v-model="item.personName" placeholder="请输入姓名" />
                  </div>
                </div>
                <div class="input-wrap">
                  <div class="key">身份证号</div>
                  <div class="val">
                    <van-field v-model="item.personIdCard" placeholder="请输入身份证号" />
                  </div>
                </div>
                <div class="input-wrap">
                  <div class="key">手机号</div>
                  <div class="val">
                    <van-field v-model="item.personPhone" placeholder="请输入手机号" />
                  </div>
                </div>
                <div class="input-wrap">
                  <div class="key">开始日期</div>
                  <div class="val">
                    <van-cell-group>
                      <van-cell
                        :title="form.itemList[index]['checkStartTime']"
                        @click="onHandleChoiceDate(index)"
                        :class="[{ link: !isLink }]"
                      >
                        <template #right-icon>
                          <img class="right-icon" src="@/assets/shuLan/icon-clock.png" />
                        </template>
                      </van-cell>
                      <van-calendar v-model="show" :min-date="minDate" @confirm="onConfirm" color="#07A8FF" />
                    </van-cell-group>
                  </div>
                </div>
              </section>
              <section class="section-content">
                <img class="sec-title" src="@/assets/shuLan/block-3.png" />
                <div class="project-list">
                  <ul v-for="(listItem, listIndex) in list" :key="listIndex">
                    <li
                      v-for="projectItem in listItem"
                      :key="projectItem.id"
                      :class="[{ active: item.productList.find((p) => p.productId == projectItem.id) }]"
                      @click="onHandleChoice(index, projectItem)"
                    >
                      <p class="title">{{ projectItem.name }}</p>
                      <p class="title">{{ projectItem.tag }}</p>
                      <p class="middle"></p>
                      <p>￥{{ projectItem.label }}</p>
                      <div
                        class="item-success"
                        v-if="item.productList.find((p) => p.productId == projectItem.id)"
                      >
                        <img src="@/assets/shuLan/select.png" />
                      </div>
                    </li>
                  </ul>
                </div>
              </section>
              <section class="money section-content" v-if="item.productList.length">
                <img class="sec-title" src="@/assets/shuLan/block-4.png" />
                <div
                  v-for="(expendItem, expendIndex) in expendList"
                  :key="expendIndex"
                  class="money-info"
                >
                  <div
                    v-if="item.productList.find((p) => p.productId == expendItem.id)"
                    class="money-info_content"
                  >
                    <span>{{ expendItem.name }}{{ expendItem.tag }}</span>
                    <span style="display: flex; align-items: center">
                      ￥{{ expendItem.label }} &nbsp;&nbsp;
                      <van-stepper
                        @change="stepperChange(index)"
                        v-model="item.productList.find((p) => p.productId == expendItem.id).productCount"
                        integer
                      />
                    </span>
                  </div>
                </div>
                <div class="money-footer">
                  <span>总计</span>
                  <span>￥{{ item.sum }}</span>
                </div>
              </section>

              <div class="remove-info">
                <div class="remove-user flex flex-column-center" @click="onHandleRemove(index)"></div>
              </div>
            </div>
          </div>
          <div class="add-info">
            <div class="add-user flex flex-column-center" @click="onHandleAdd"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <div class="info-footer flex flex-between flex-align-center">
      <dl>
        <dt>总计</dt>
        <dd>￥{{ sum }}</dd>
      </dl>
      <div class="info-footer_right">
        <div class="save btn" @click="onHandleSave"></div>
        <div class="pay-now btn" @click="onHandleSubmit"></div>
      </div>
    </div>
    <van-overlay :show="loading">
      <van-loading size="40" vertical class="loadingDiv">支付中...</van-loading>
    </van-overlay>
  </div>
</template>
<script>
import { Toast } from "vant";
import { list, expendList, item } from "./config";
import { onSettleInfoSubmitShuLan, onSettleInfoSubmitChangGanNao } from "@/api";
import * as changGanNaoConfig from "@/views/changGanNao/config";
import { weixinInit } from "@/utils/wechatUtil.js";
import { buildChangGanNaoOAuthUrl } from "@/utils/changGanNaoOAuth";

export default {
  props: {
    productMark: { type: Number, default: 37 },
  },
  data() {
    const isChangGanNao = this.productMark === 47;
    return {
      title: "请选择日期",
      isLink: true,
      show: false,
      loading: false,
      urlString: "",
      list: isChangGanNao ? changGanNaoConfig.list : list,
      expendList: isChangGanNao ? changGanNaoConfig.expendList : expendList,
      cacheKey: isChangGanNao ? "changGanNao_cache" : "shuLan_cache",
      successPath: isChangGanNao ? "/changGanNaoInfoSuccess" : "/shuLanInfoSuccess",
      form: {
        payPersonName: "",
        payPersonNo: "",
        payPersonPhone: "",
        itemList: [JSON.parse(JSON.stringify(item))],
      },
      sum: 0,
      orgId: "",
      areaCode: "",
      currentItem: null,
      currentIndex: 0,
    };
  },
  async created() {
    var currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + 1);
    this.minDate = currentDate;
    this.orgId = localStorage.getItem("orgId") || "";
    this.areaCode = localStorage.getItem("areaCode") || "";
    this.urlString = window.location.href.split("#")[0];
    const form = localStorage.getItem(this.cacheKey);
    if (form) {
      this.form = JSON.parse(form);
      this.onGetTotalSum();
    }
    this.wxConfigInit();
  },
  methods: {
    onHandleChoiceDate(index) {
      this.currentIndex = index;
      this.currentItem = this.form.itemList[index];
      this.show = true;
    },
    onPad(num) {
      return num < 10 ? "0" + num : num;
    },
    formatDate(date) {
      return `${date.getFullYear()}-${this.onPad(date.getMonth() + 1)}-${this.onPad(date.getDate())}`;
    },
    onConfirm(date) {
      this.show = false;
      this.form.itemList[this.currentIndex]["checkStartTime"] = this.formatDate(date);
      this.isLink = false;
      this.title = this.form.itemList[this.currentIndex]["checkStartTime"];
    },
    async wxConfigInit() {
      await weixinInit({ publicType: 1, url: this.urlString });
    },
    async weixinPay(weixinPayParam) {
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener("WeixinJSBridgeReady", this.onBridgeReady.bind(this, weixinPayParam), false);
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady.bind(this, weixinPayParam));
        }
      } else {
        this.onBridgeReady(weixinPayParam);
      }
    },
    async onBridgeReady(weixinPayParam) {
      let payNoDiy = weixinPayParam.payNo;
      const successPath = this.successPath;
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: weixinPayParam.appId,
          timeStamp: weixinPayParam.timeStamp,
          nonceStr: weixinPayParam.nonceStr,
          package: weixinPayParam.packages,
          signType: weixinPayParam.signType,
          paySign: weixinPayParam.paySign,
        },
        function () {
          window.location.href = "https://yisheng.healthmore.net" + successPath + "?payNo=" + payNoDiy;
        }
      );
    },
    onHandleAdd() {
      this.form.itemList.push(JSON.parse(JSON.stringify(item)));
    },
    onHandleRemove(index) {
      if (this.form.itemList.length === 1) {
        Toast("至少保留一个用户信息");
        return;
      }
      this.form.itemList.splice(index, 1);
      this.onGetTotalSum();
    },
    onHandleChoice(index, item) {
      const productList = this.form.itemList[index]["productList"];
      const selectIndex = productList.findIndex((p) => p.productId == item.id);
      if (selectIndex != -1) {
        productList.splice(selectIndex, 1);
      } else {
        productList.push({ productId: item.id, productCount: 1, price: item.label });
      }
      const sum = productList.reduce((s, p) => s + p.price * p.productCount, 0);
      this.form.itemList[index]["sum"] = sum;
      this.onGetTotalSum();
    },
    stepperChange(listIdx) {
      let sum = 0;
      this.form.itemList[listIdx]["productList"].forEach((p) => {
        const found = this.expendList.find((e) => e.id == p.productId);
        sum += found.label * p.productCount;
      });
      this.form.itemList[listIdx]["sum"] = sum;
      this.onGetTotalSum();
    },
    onGetTotalSum() {
      this.sum = this.form.itemList.reduce((total, item) => total + (Number(item.sum) || 0), 0);
    },
    onHandleSave() {
      localStorage.setItem(this.cacheKey, JSON.stringify(this.form));
      Toast("暂存成功");
    },
    onHandleSubmit() {
      if (!this.form.payPersonName) { Toast("请填写业务员姓名"); return; }
      if (!this.form.payPersonNo) { Toast("请填写业务员工号"); return; }
      if (!this.form.payPersonPhone) { Toast("请先输入业务员手机号"); return; }
      if (this.form.payPersonPhone.length != 11) { Toast("请输入正确的业务员手机号"); return; }
      const list = this.form.itemList;
      for (let i = 0; i < list.length; i++) {
        if (!list[i].personName) { Toast("请填写客户姓名"); return; }
        if (!list[i].personIdCard) { Toast("请填写客户身份证号"); return; }
        if (!list[i].personPhone) { Toast("请填写客户手机号"); return; }
        if (list[i].personPhone.length != 11) { Toast("请输入正确的客户手机号"); return; }
        if (!list[i].checkStartTime) { Toast("请选择检查日期"); return; }
        if (!list[i].productList.length) { Toast("请至少选择一个项目"); return; }
      }
      this.onHandleFinalSumit();
    },
    async onHandleFinalSumit() {
      if (this.loading) return;
      this.loading = true;
      let code = localStorage.getItem("code") || "";
      let values = {
        wxCode: code,
        saleOrgId: this.orgId,
        areaCode: this.areaCode,
        ...this.form,
      };
      try {
        const submit = this.productMark === 47 ? onSettleInfoSubmitChangGanNao : onSettleInfoSubmitShuLan;
        const res = await submit(values);
        if (res.code == 200) {
          this.weixinPay(res.data);
        } else if (this.productMark === 47 && (res.code == 40029 || res.code == 40163)) {
          // 授权失效时保留录入内容，回跳后可继续支付，无需重新扫码或登录。
          localStorage.setItem(this.cacheKey, JSON.stringify(this.form));
          localStorage.removeItem("code");
          this.loading = false;
          this.$toast("微信授权已失效，重新授权后请再次点击立即支付");
          window.location.replace(buildChangGanNaoOAuthUrl({
            ...this.$route.query,
            orgId: this.orgId,
            companyId: localStorage.getItem("companyId"),
            areaCode: this.areaCode,
          }));
        } else {
          this.$toast(res.msg);
          this.loading = false;
        }
      } catch (err) {
        console.log("err", err);
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.van-text-cus {
  display: flex;
  align-items: center;
  .van-field {
    padding-left: 5px;
    /deep/.van-field__control { color: #ff3c1c; }
  }
}
.section-content {
  background-color: #fff;
  border-radius: 16px;
  padding: 0 15px 15px;
  margin-bottom: 40px;
  .sec-title {
    position: relative;
    top: -20px;
    left: -15px;
    height: 45px;
  }
}
* { box-sizing: border-box; }
.head-img {
  width: 100%;
  max-width: 402px;
  margin-top: -30px;
}
img { display: block; max-width: 100%; }
.head-wrap {
  padding: 0px 0 50px;
  overflow: hidden;
  .title { width: 298px; margin-bottom: 30px; }
  .des { width: 165px; }
}
.content-padding { padding-left: 20px; padding-right: 20px; }
.section {
  border-radius: 12px;
  margin-bottom: 16px;
  .content { padding-top: 20px; border-radius: 12px; }
}
.input-wrap {
  margin-bottom: 16px;
  .key { color: #363636; font-size: 14px; margin-bottom: 12px; }
  .val {
    /deep/ .van-cell {
      border: none;
      background-color: #eaf6fe;
      /deep/input::placeholder { color: #b8d7eb !important; }
    }
  }
}
.label { color: #363636 !important; font-size: 14px !important; margin-bottom: 12px !important; }
img { margin: 0; display: block; }
/deep/ .right-icon { width: 18px; height: 18px; }
.loadingDiv { position: absolute; left: 42%; top: 40%; }
.info {
  position: relative;
  padding-bottom: 100px;
  background-color: #bbdefa;
  &-banner { width: 100%; }
  .manage-info {
    overflow: hidden;
    margin-bottom: 20px;
    &-title { background-repeat: no-repeat; background-size: 100% 100%; }
    &-repeat { background-repeat: repeat-y; background-size: 100% 100%; }
    &_content {
      padding-top: 20px;
      .link /deep/ .van-cell__title { color: #333; }
      & > p { color: #000; font-size: 14px; margin-bottom: 10px; font-weight: 900; }
      /deep/ .van-cell::after { border-bottom: none; }
      .project-list {
        margin: -3px;
        ul {
          display: flex;
          margin-bottom: 6px;
          flex-wrap: wrap;
          li {
            width: auto;
            position: relative;
            border: 1px solid #b8d7eb;
            border-radius: 8px;
            padding: 6px 9px 4px;
            margin: 3px;
            &.active { border: 1px solid #0374c3; }
            &:last-child { margin-right: 0; }
            .item-success {
              position: absolute;
              right: -1px;
              top: -1px;
              width: 16px;
              height: 16px;
              img { position: absolute; width: 100%; height: 100%; }
            }
            p {
              font-size: 11px;
              color: rgb(255, 60, 28);
              margin: 8px 0;
              text-align: center;
              font-weight: 900;
              &.title { font-size: 11px; font-weight: 500; color: #363636; margin: 2px 0; }
              &.middle {
                margin: 10px 8px;
                height: 1px;
                background: url("../../assets/shuLan/line.png");
                background-repeat: no-repeat;
                background-size: 100% 100%;
              }
            }
          }
        }
      }
      .money {
        &-title { color: #363636; font-size: 14px; margin-bottom: 12px; }
        &-info {
          &_content {
            display: flex;
            justify-content: space-between;
            margin: 14px 0;
            span {
              font-size: 13px;
              color: rgb(30, 30, 30);
              font-weight: 400;
              &:last-child { color: rgb(255, 60, 28); }
            }
          }
        }
        &-footer {
          display: flex;
          justify-content: space-between;
          padding: 16px 0;
          border-top: 1px solid #eaf6fe;
          span {
            font-size: 16px;
            font-weight: 900;
            color: rgba(30, 30, 30);
            &:last-child { color: rgb(255, 60, 28); }
          }
        }
      }
    }
  }
  .add-info {
    padding: 0 15px 20px;
    background-color: #f7fcff;
    margin-top: -21px;
    border-radius: 0 0 16px 16px;
  }
  .remove-info { margin-top: -50px; background-color: #fff; padding: 15px; }
  .add-user {
    background: url("../../assets/shuLan/btn-add.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 50px;
  }
  .remove-user {
    background: url("../../assets/shuLan/btn-remove.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 45px;
  }
  &-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background: #fff;
    border-radius: 16px 16px 0 0;
    padding: 20px 12px 30px;
    dl {
      dt { font-size: 12px; color: #000; }
      dd { font-size: 18px; color: rgb(255, 60, 28); font-weight: 900; }
    }
    &_right {
      font-size: 16px;
      font-weight: 900;
      display: flex;
      .btn { width: 111px; height: 42px; background-size: contain; background-repeat: no-repeat; background-position: center; }
      .save { background-image: url("../../assets/shuLan/btn-l.png"); padding: 7px 40px; }
      .pay-now { background-image: url("../../assets/shuLan/btn-r.png"); padding: 7px 20px; }
    }
  }
}
.info {
  background-image: url("../../assets/shuLan/body-bg.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
</style>
